<template>
  <div class="app-footer">
    <footer class="footer font-roboto" style="background-color: #E31A6C; padding: 4rem;">
      <div class="container has-text-centered">
        <span class="has-text-weight-semibold is-size-4 has-text-white">Made with&nbsp;</span>
        <span class="icon is-size-4">
          <i class="fas fa-heart" style="color: #952186;"></i>
        </span>
        <span class="has-text-weight-semibold is-size-4 has-text-white">
          by
          <a class="link-custom-1 is-size-5" href="https://avishj.dev" target="_blank">avishj</a>
          at
          <a
            class="link-custom-1"
            href="https://codechefvit.com"
            target="_blank"
          >CodeChefVIT.</a>
        </span>
        <br class="my-1" />
        <span class="icon is-size-5 has-text-white p-1">
          <a class="link-custom-1" href="https://www.facebook.com/codechefvit/" target="_blank">
            <i class="fab fa-facebook fa-lg"></i>
          </a>
        </span>
        &emsp;
        <span class="icon is-size-5 has-text-white p-1">
          <a class="link-custom-1" href="https://www.twitter.com/codechefvit" target="_blank">
            <i class="fab fa-twitter fa-lg"></i>
          </a>
        </span>
        &nbsp;&nbsp;
        <span class="icon is-size-5 has-text-white p-1">
          <a class="link-custom-1" href="https://instagram.com/codechefvit/" target="_blank">
            <i class="fab fa-instagram fa-lg"></i>
          </a>
        </span>
        &nbsp;&nbsp;
        <span class="icon is-size-5 has-text-white p-1">
          <a class="link-custom-1" href="https://github.com/CodeChefVIT" target="_blank">
            <i class="fab fa-github fa-lg"></i>
          </a>
        </span>
        &nbsp;&nbsp;
        <span class="icon is-size-5 has-text-white p-1">
          <a class="link-custom-1" href="https://medium.com/codechef-vit" target="_blank">
            <i class="fa fa-medium fa-lg"></i>
          </a>
        </span>
        &nbsp;&nbsp;
        <span class="icon is-size-5 has-text-white p-1">
          <a
            class="link-custom-1"
            href="https://www.linkedin.com/company/codechef-vit-chapter"
            target="_blank"
          >
            <i class="fab fa-linkedin fa-lg"></i>
          </a>
        </span>
        &nbsp;&nbsp;
        <span class="icon is-size-5 has-text-white p-1">
          <a
            class="link-custom-1"
            href="https://www.youtube.com/channel/UCzFltCrQSB1CKmX440yqTKw"
            target="_blank"
          >
            <i class="fab fa-youtube fa-lg"></i>
          </a>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
</style>
